<template>
  <div class="is-expandable">
    <b-field :label="$t(label)">
      <p class="control is-expandable">
        <b-taginput
          v-model="selection"
          :data="filteredOptions"
          autocomplete
          ref="tagInput"
          field="title"
          icon="label"
          @focus="focusEvent()"
          @input="$emit('input', selected)"
          @typing="getFilteredTags"
        >
          <template slot="empty">
            {{ $t('No hay resultados') }}
          </template>
        </b-taginput>
      </p>
      <button @click="addAll" class="button is-primary">
        {{ $t('Todos') }}
      </button>
    </b-field>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    options: Array,
    value: Array,
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      filteredOptions: [],
      selected: this.value
    }
  },
  watch: {
    value: function(val) {
      this.selected = val
    }
  },
  computed: {
    formatedSelection: function() {
      let formatedSelection = []
      this.selected.forEach(function(element) {
        formatedSelection.push(element)
      })
      return formatedSelection
    },
    selection: {
      get() {
        let self = this
        let result = this.options.filter(elem =>
          self.selected.includes(elem.id)
        )
        return result
      },
      set(elems) {
        let self = this
        self.selected = []
        elems.forEach(function(element) {
          self.selected.push(element.id)
        })
      }
    }
  },
  mounted() {
    this.filteredOptions = this.options
  },
  methods: {
    focusEvent() {
      this.$refs.tagInput.$refs.autocomplete.isActive = true
    },
    addAll() {
      let self = this
      self.selected = []
      self.formatedSelection = []
      self.options.forEach(function(element) {
        self.selected.push(element.id)
        self.formatedSelection.push(element)
      })
      self.$emit('input', self.selected)
    },
    getFilteredTags(text) {
      this.filteredOptions = this.options.filter(option => {
        return (
          option.title
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        )
      })
    }
  }
}
</script>
<style>
.is-expandable {
  flex-grow: 1;
  flex-basis: 100px;
}
.button.is-primary {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
